import React from 'react';
import { isRollout0Feature, contactInfo } from '../../config/featureFlags';

const ServiceArea: React.FC = () => {
  if (!isRollout0Feature('serviceAreaInfo')) return null;

  return (
    <div className="bg-gradient-to-b from-slate-50 to-white py-16">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-2xl sm:text-3xl font-bold text-slate-800 mb-3">
          Proudly Serving Central Florida
        </h2>
        <p className="text-gray-600 mb-8 max-w-xl mx-auto">
          Expert roofing services throughout Highlands County and surrounding areas
        </p>
        <div className="flex flex-wrap justify-center gap-3 max-w-2xl mx-auto">
          {contactInfo.serviceArea.map((area) => (
            <span
              key={area}
              className="inline-flex items-center gap-1.5 bg-white px-5 py-2.5 rounded-full shadow-sm text-slate-700 font-medium border border-slate-200 hover:border-lime-300 hover:shadow-md transition-all"
            >
              <span className="w-2 h-2 rounded-full bg-lime-500"></span>
              {area}
            </span>
          ))}
        </div>
        <p className="text-sm text-gray-500 mt-8">
          Don't see your area?{' '}
          <a href="tel:+18634534555" className="text-lime-600 hover:text-lime-700 font-semibold">
            Call (863) 453-4555
          </a>
          {' '}— we may still be able to help!
        </p>
      </div>
    </div>
  );
};

export default ServiceArea;
